import { render } from "./EmployeeEmergencyContacts.vue?vue&type=template&id=8146ff56&scoped=true"
import script from "./EmployeeEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmployeeEmergencyContacts.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=8146ff56&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8146ff56"]])

export default __exports__